module.exports = __webpack_public_path__ + "static/media/image4.5b5b19da.JPG";